define('common',['require'],function(require) {
	'use strict';

	require(['classes/basket'], function(Basket) {
	    new Basket().initiate();
	});

	//require(['classes/MaintainScrollPosition'], function(maintainScrollPosition) {
	//	maintainScrollPosition.initiate();
	//});

	require(['classes/heart', 'classes/geolocation', 'classes/datalayer', 'fastclick', 'classes/url'], function(Heart, Geo, DataLayer, FastClick) {
		new Heart();
		new Geo();
		new DataLayer();

		document.addEventListener('DOMContentLoaded', function() {
			FastClick.attach(document.body);
		}, false);
	});

	require(['classes/nosto'], function(Nosto) {
		new Nosto({
			'market': dataLayer[0].countryCode
		}).initiate();
	});

	require(['postal', 'lodash'], function(postal, _) {
		// catch scroll events
		var publishScroll = function() {
			postal.channel('page').publish({
				topic: 'scroll'
			});
		};

		// catch resize events
		var publishResize = function() {
			postal.channel('page').publish({
				topic: 'resize'
			});
		};

		window.addEventListener('scroll', publishScroll);
		window.addEventListener('touchmove', publishScroll);
		window.addEventListener('resize', _.debounce(publishResize, 500));
	});

	// old
	window.assets = window.assets || {};

	require(['classes/message'], function(message) {
		window.assets.message = message;
		window.assets.message.initiate(function() {
			console.log('message initiated the old way');
		});
	});

	require(['classes/marketgateway'], function(language) {
		window.assets.language = language;
		window.assets.language.initiate(function() {
			console.log('language initiated the old way');
		});
	});

	require(['classes/topnavigation'], function(navigation) {
		window.assets.navigation = navigation;
		window.assets.navigation.initiate(function() {
			console.log('navigation initiated the old way');
		});
	});

	require(['classes/footer'], function(footer) {
		window.assets.footer = footer;
		window.assets.footer.initiate(function() {
			console.log('footer initiated the old way');
		});
	});

	require(['classes/voucher'], function(voucher) {
		window.assets.voucher = voucher;
		window.assets.voucher.initiate(function() {
			console.log('voucher initiated the old way');
		});
	});

	require(['classes/mailchimp'], function (mailchimp) {
	    
		window.assets.mailchimp = mailchimp;
		window.assets.mailchimp.initiate(function() {
			console.log('mailchimp initiated the old way');
		});
	});

	require(['classes/shippingcountryselector'], function (shippingcountryselector) {
	    window.assets.shippingCountrySelector = shippingcountryselector;
	    window.assets.shippingCountrySelector.initiate(function () {
	        console.log('shippingcountryselectrol initiated the old way');
	    })
	});

	require(['classes/position'], function(position) {
		window.assets.position = position;
	});
});
